var irreducible = require('./irreducible');
var isType = require('./isType');

module.exports = irreducible('Type', isType);